/* eslint no-bitwise: 0 */
/* eslint no-else-return: 0 */
/* eslint semi: 0 */
/* eslint eqeqeq: 0 */
/* eslint no-use-before-define: 0 */
/* eslint no-param-reassign: 0 */
/* eslint import/prefer-default-export: 0 */
/* eslint no-plusplus: 0 */
/* eslint no-multi-assign: 0 */
/* eslint object-shorthand: 0 */
/* eslint no-shadow: 0 */
/* eslint no-await-in-loop: 0 */

const b2 = (d, b) => d[b] | (d[b + 1] << 8);
const b4 = (d, b) => (d[b] | (d[b + 1] << 8) | (d[b + 2] << 16) | (d[b + 3] << 24)) >>> 0;
const b8 = (d, b) => b4(d, b) + (b4(d, b + 4) * 4294967296);
const cp866 = new TextDecoder('cp866');
const td = new TextDecoder('utf8');

function rds(dat, latin1) {
    if (latin1) {
        return cp866.decode(dat);
    } else {
        return td.decode(dat)
    }
}

const zh = (d, b, z) => {
    const fnl = b2(d, b + 28);
    const flags = b2(d, b + 8);
    const fn = rds(d.subarray(b + 46, b + 46 + fnl), !(flags & 2048));
    const es = b + 46 + fnl;
    const bs = b4(d, b + 20);
    const [sc, su, off] = z && bs == 4294967295 ? z64e(d, es) : [bs, b4(d, b + 24), b4(d, b + 42)];
    return [b2(d, b + 10), sc, su, fn, es + b2(d, b + 30) + b2(d, b + 32), off];
}

const z64e = (d, b) => {
    for (; b2(d, b) != 1; b += 4 + b2(d, b + 2));
    return [b8(d, b + 12), b8(d, b + 4), b8(d, b + 20)];
}

const slzh = (d, b) => b + 30 + b2(d, b + 26) + b2(d, b + 28);

export class ZipFile {
    entries = {};

    constructor(data) {
        this.data = data;
        let e = data.length - 22;
        for (; b4(data, e) != 0x6054b50; --e) {
            if (!e || data.length - e > 65558) {
                throw new Error('invalid zip');
            }
        }
        let lft = b2(data, e + 8);
        if (lft) {
            let c = lft;
            let o = b4(data, e + 16);
            let z = o == 4294967295 || c == 65535;
            if (z) {
                const ze = b4(data, e - 12);
                z = b4(data, ze) == 0x6064b50;
                if (z) {
                    c = lft = b4(data, ze + 32);
                    o = b4(data, ze + 48);
                }
            }
            for (let i = 0; i < c; ++i) {
                const [c, sc, su, fn, no, off] = zh(data, o, z);
                const b = slzh(data, off);
                o = no;
                this.entries[fn] = {
                    sc: sc,
                    su: su,
                    c: c,
                    p: b,
                }
            }
        }
    }

    async readEntry(entry) {
        const infl = this.data.subarray(entry.p, entry.p + entry.sc);
        if (entry.c === 0) {
            return infl;
        } else if (entry.c === 8) {
            const ds = new DecompressionStream('deflate-raw');
            const writer = ds.writable.getWriter();
            writer.write(infl);
            writer.close();
            const output = [];
            const reader = ds.readable.getReader();
            let totalSize = 0;
            for (;;) {
                const {
                    value,
                    done,
                } = await reader.read();
                if (done) {
                    break;
                }
                output.push(value);
                totalSize += value.byteLength;
            }
            if (output.length === 1) {
                return output[0];
            }
            const concatenated = new Uint8Array(totalSize);
            let offset = 0;
            for (const array of output) {
                concatenated.set(array, offset);
                offset += array.byteLength;
            }
            return concatenated;
        } else {
            throw new Error('invalid zip');
        }
    }
}
